import React from 'react';

const WhatMakesDifferent = () => {
  return (
    <section className="section bg-neutral-light">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="mb-4 font-bold">What Makes This <span className="text-primary">Different</span></h2>
            <p className="text-lg text-secondary-light">
              Most web designers send you a proposal and ask for money upfront.<br />
              We build first, then show you what's possible.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="glass-card p-6 flex items-start gap-4 hover:shadow-soft-lg transition-all duration-300">
              <div className="text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">No risk - see your website before paying</h3>
                <p className="text-secondary-light">We show you exactly what you're getting before you commit to the full investment.</p>
              </div>
            </div>
            
            <div className="glass-card p-6 flex items-start gap-4 hover:shadow-soft-lg transition-all duration-300">
              <div className="text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">No generic templates - custom built for your business</h3>
                <p className="text-secondary-light">Every website is tailored specifically to your business, services, and target audience.</p>
              </div>
            </div>
            
            <div className="glass-card p-6 flex items-start gap-4 hover:shadow-soft-lg transition-all duration-300">
              <div className="text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">No lengthy sales process - the work is already done</h3>
                <p className="text-secondary-light">Skip the multiple meetings and proposals - we've already built what you need.</p>
              </div>
            </div>
            
            <div className="glass-card p-6 flex items-start gap-4 hover:shadow-soft-lg transition-all duration-300">
              <div className="text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">No surprises - transparent pricing and process</h3>
                <p className="text-secondary-light">Clear pricing, straightforward process, and predictable timeline. No hidden fees or surprises.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatMakesDifferent;
